import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { DataGrid } from "@mui/x-data-grid";
import { unwrapResult } from "@reduxjs/toolkit";
import { Select } from "antd";
import Card from "components/Card/Card.js";
import GridItem from "components/Grid/GridItem.js";

import { Link } from "react-router-dom";
import {
  fetchKPIsByProgram,
  updateKPIPlanning
} from "../../../../reduxToolkit/features/KPI/KPIProgramSlice.jsx";

import { Breadcrumb, notification } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { fetchProgramById } from "reduxToolkit/features/program/ProgramsSlice.js";
import { fetchAcademicYearById } from "../../../../reduxToolkit/features/academicYear/AcademicYearsSlice";
import { fetchSemesterById } from "../../../../reduxToolkit/features/semester/SemestersSlice.js";

import moment from "moment";
import ErrorModal from "../../../Components/ErrorModal";
import "./index.css";

const { Option } = Select;

export default function KPI({ match }) {

  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { id } = match.params;
  const { program_id } = match.params;
  const { semesterId } = match.params;

  const [pageSize, setPageSize] = useState(9);
  const [openSpinner, setOpenSpinner] = useState(true);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [handledError, setHandledError] = useState("");

  const AllKPIs = useSelector((state) => state.KPIProgram.KPIs);
  const semester = useSelector((state) => state.semester.semester);
  const academicYear = useSelector((state) => state.academicYear.academicYear);
  const program = useSelector((state) => state.program.program)

  useEffect(() => {
    fetchSemester(semesterId);
    fetchAcademicYear(id);
    fetchProgram(program_id);
  }, []);

  useEffect(() => {
    dispatch(fetchKPIsByProgram(program_id))
        .then(unwrapResult)
        .then((AllKPIs) => {
          handleCloseSpinner();
        });
  }, []);

  const fetchSemester = async (id) => {
    try {
      dispatch(fetchSemesterById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const fetchProgram = async (id) => {
    try {
      dispatch(fetchProgramById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const fetchAcademicYear = async (id) => {
    try {
      await dispatch(fetchAcademicYearById(id)).unwrap();
    } catch (err) {
      setHandledError(err);
      handleOpenErrorModal();
    }
  };

  const handleCloseSpinner = () => {
    setOpenSpinner(false);
  };

  const handleOpenErrorModal = () => {
    setOpenErrorModal(true);
  };

  const handleCloseErrorModal = () => {
    setOpenErrorModal(false);
  };

  const openNotificationWithIcon = (type, msg) => {
    notification[type]({
      message: type,
      description: msg,
      top: 50,
      duration: 2,
    });
  };

  const onCellEditCommit = async (event) => {
    if (event.value !== null) {
      console.log("onCellEditCommit", event);
      const value =
        event.field === "target" ||
          event.field === "external_benchmark" ||
          event.field === "internal_benchmark"
          ? event.value
          : moment(event.value).format("YYYY-MM-DD");
      const field = event.field;
      const updated = {
        [field]: value,
      };
      const id = event.id;
      const resultAction = await dispatch(
        updateKPIPlanning({ id: id, updated: updated })
      );
      if (updateKPIPlanning.fulfilled.match(resultAction)) {
        openNotificationWithIcon("success", `Updated successfully`);
      } else {
        if (resultAction.payload) {
          setHandledError(resultAction.payload);
          handleOpenErrorModal();
        } else {
          setHandledError(resultAction.error);
          handleOpenErrorModal();
        }
      }
    }
  };

  return (
    <div>
      <div>
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={openSpinner}
          onClick={handleCloseSpinner}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      </div>
      <div>
        <GridItem style={{ marginBottom: "5px" }}>
          <Breadcrumb separator=">">
            <Breadcrumb.Item>{t("Planning")}</Breadcrumb.Item>
            <Breadcrumb.Item>{t("Academic Calender")}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/planning/academicCalender/academicYears`}>
                {t("Academic years")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}`}
              >
                {t(`${academicYear && academicYear.name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>{t("semesters")}</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}/semesters/${semesterId}`}
              >
                {t(`${semester && semester.name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link
                to={`/citrine/planning/academicCalender/academicYears/${id}/semesters/${semesterId}/program/${program_id}`}
              >
                {t(`${program && program.program_degree_name}`)}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/citrine/planning/programAssessment/KPI`}>
                {t("KPIs Planning ")}
              </Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        </GridItem>
        <Card>
          <div style={{ height: 600, width: "100%" }}>
            <DataGrid
              rows={AllKPIs && AllKPIs}
              columns={columns}
              onCellEditCommit={onCellEditCommit}
              showCellRightBorder
              pageSize={pageSize}
              onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
              rowsPerPageOptions={[5, 10, 20, 80]}
              pagination
              getRowHeight={() => 'auto'}
            />
          </div>
        </Card>
        <ErrorModal
          open={openErrorModal}
          handleClose={handleCloseErrorModal}
          handledError={handledError}
        />
      </div>
    </div>
  );
}

const columns = [
  {
    field: "kpiConfig_name",
    headerName: "Key Performance Indicator",
    width: 250,
    sortable: true,
    renderCell: (params) => (
      <div>
        {params.row.kpiConfig_details.map((item, index) =>
          <p style={{ paddingTop: 10 }}>
            {item.code}
          </p>
        )}
      </div>
    ),
  },
  {
    field: "assessment_start_date",
    headerName: "Assessment Start Date",
    type: "date",
    width: 150,
    editable: true,
    sortable: true,
  },
  {
    field: "assessment_due_date",
    headerName: "Assessment Due Date",
    type: "date",
    width: 150,
    editable: true,
    sortable: true,
  },
  {
    field: "improvement_due_date",
    headerName: "Improvement Due Date",
    type: "date",
    width: 150,
    editable: true,
    sortable: true,
  },
  {
    field: "external_benchmark",
    headerName: "External Benchmark",
    width: 140,
    editable: true,
    sortable: true,
  },
  {
    field: "internal_benchmark",
    headerName: "Internal Benchmark",
    width: 140,
    editable: true,
    sortable: true,
  },
  {
    field: "target",
    headerName: "Target",
    width: 120,
    editable: true,
    sortable: true,
    type: 'number',
  },
];
